// Footer.js

import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-secondary text-light text-center py-3">
      <p>&copy; 2023 Your Website Name. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
